import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories-section" className="px-4 md:px-6 py-12 md:py-16 bg-background-50" aria-labelledby="categories-heading">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 id="categories-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            视频分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            涵盖蜜桃视频、红桃视频、樱桃视频等丰富分类，总有你喜欢的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              aria-label={`查看 ${cat.name} 分类`}
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-3 transition-transform duration-300 group-hover:scale-110 ${
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-700'
              }`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 line-clamp-2 text-center leading-relaxed">
                {cat.description.slice(0, 30)}...
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}